// extracted by mini-css-extract-plugin
module.exports = {"btn-record-payment":"_3ncM2hMHsR5MarME3x0K5T","resend":"_1pgstVCU2gaxD1kjwrLT6-","mr-btn":"_2Ie4sAQHYxWMh3AF4i7LJi"};